import { render, staticRenderFns } from "./CourseContents.vue?vue&type=template&id=11f3dae8"
import script from "./CourseContents.vue?vue&type=script&lang=js"
export * from "./CourseContents.vue?vue&type=script&lang=js"
import style0 from "./CourseContents.vue?vue&type=style&index=0&id=11f3dae8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports